<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">devices</mat-icon>
    <span class="section-title">{{ 'ai.getSignagePlayer' | transloco }}</span>
    <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content class="dialog-body">
    <!-- Hero Section -->
    <div class="hero-section">
        <div class="hero-content">
            <mat-icon class="hero-icon">cast_connected</mat-icon>
            <div class="hero-text">
                <h2>{{ 'ai.chooseYourPlayer' | transloco }}</h2>
                <p>{{ 'ai.playerDescription' | transloco }}</p>
            </div>
        </div>
    </div>

    <!-- Player Options Grid -->
    <div class="players-grid">
        @for (option of playerOptions; track option.id) {
            <div class="player-card" [class.recommended]="option.badge === 'recommended'" (click)="onSelectOption(option)">
                @if (option.badge) {
                    <div class="badge" [style.background]="option.color">
                        <mat-icon>star</mat-icon>
                        <span>{{ option.badge }}</span>
                    </div>
                }

                <div class="card-header">
                    <div class="icon-wrapper" [style.background]="'linear-gradient(135deg, ' + option.color + ', ' + option.color + '99)'">
                        <mat-icon>{{ option.icon }}</mat-icon>
                    </div>
                    <div class="title-section">
                        <h3>{{ option.name }}</h3>
                        <p>{{ option.description }}</p>
                    </div>
                </div>

                <div class="features-list">
                    @for (feature of option.features; track feature) {
                        <div class="feature-item">
                            <mat-icon [style.color]="option.color">check_circle</mat-icon>
                            <span>{{ feature }}</span>
                        </div>
                    }
                </div>

                <button class="action-btn" [style.background]="'linear-gradient(135deg, ' + option.color + ', ' + option.color + 'cc)'">
                    <mat-icon>{{ option.actionIcon }}</mat-icon>
                    <span>{{ option.actionLabel }}</span>
                </button>
            </div>
        }
    </div>

    <!-- Footer Section -->
    <div class="footer-section">
        <div class="info-banner">
            <mat-icon>info</mat-icon>
            <span>{{ 'ai.allPlayersSupport' | transloco }}</span>
        </div>
        <button class="learn-more-btn" (click)="onLearnMore()">
            <mat-icon>open_in_new</mat-icon>
            <span>{{ 'ai.viewAllDevices' | transloco }}</span>
        </button>
    </div>
</div>
